import { ProviderType } from 'features/connections'
import { CentroidSettingsQuery } from '../types'
import { OperationType } from 'features/analysis/types'
import { buildAnalysisQueryFromSource, getQFromQuery } from '../../utils'
import { generateQuery as generateQueryRedshift } from './rs'

export function generateCentroidQuery(payload: CentroidSettingsQuery) {
  const { mainSource } = payload
  const connectionProvider = mainSource.providerId
  switch (connectionProvider) {
    case ProviderType.BIGQUERY:
      return generateQuery(payload)
    case ProviderType.SNOWFLAKE:
      return generateQuery(payload)
    case ProviderType.REDSHIFT:
      return generateQueryRedshift(payload)
    case ProviderType.POSTGRES:
      return generateQuery(payload)
    default:
      throw new Error(`Analysis not implemented for ${connectionProvider}`)
  }
}

export function generateQuery(payload: CentroidSettingsQuery) {
  const { mainSource, aggregationOperation, aggregationField, categorizeBy } = payload
  const connectionProvider = mainSource.providerId
  const baseQuery = buildAnalysisQueryFromSource({ source: mainSource })
  const lastQuery = getQFromQuery(baseQuery) || 1
  const geomField = mainSource.geoColumn || mainSource.metadata?.schema?.find((c) => c.type === 'geometry')?.name
  let columns = mainSource.metadata?.schema?.filter((c) => c.type !== 'geometry')
  let stCentroidFunction = `ST_CENTROID(${geomField}) AS geom`
  if (categorizeBy || aggregationOperation) {
    stCentroidFunction = `ST_CENTROID(ST_COLLECT(${geomField})) AS geom`
    if (connectionProvider === ProviderType.BIGQUERY) {
      stCentroidFunction = `ST_CENTROID_AGG(${geomField}) AS geom`
    }
  }
  let categorization = ''
  if (categorizeBy) {
    categorization = `\n\tGROUP BY\n\t\t${categorizeBy}`
    columns = [{ name: categorizeBy, type: 'string' }]
  }
  if (aggregationOperation) {
    columns = []
    columns.push({ name: generateOperation(aggregationOperation, aggregationField), type: 'number' })
    if (categorizeBy) {
      columns.push({ name: categorizeBy, type: 'string' })
    }
  }
  const query = `SELECT\n\t\t${stCentroidFunction}${columns?.length ? ',' : ''}${columns.map(
    (c) => `\n\t\t${c.name}`
  )}\n\tFROM\n\t\t__q${lastQuery}${categorization}`

  return `${baseQuery},\n__q${lastQuery + 1} AS (\n\t${query}\n)\nSELECT * FROM __q${lastQuery + 1}`
}

export function generateOperation(operation: OperationType, column?: string) {
  switch (operation) {
    case OperationType.COUNT:
      return 'COUNT(*) AS aggregated_count'
    case OperationType.AVG:
    case OperationType.SUM:
    case OperationType.MAX:
    case OperationType.MIN:
      return `${operation}(${column}) AS aggregated_${operation}`
  }
}
